import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from './api.service';
import { apiMethods, apiEndPoints} from '@constants/index';
import { IApiResponse } from '@core/models/index';

@Injectable()
export class AdminUserService {
  constructor(private readonly http: ApiService) {}

  public dashboardTiles(): Observable<IApiResponse> {
    return this.http.invoke({
      method: apiMethods.get,
      path: `${apiEndPoints.admin}${apiEndPoints.dashboardTiles}`
    });
  }

  public getAllUsers(queryParams): Observable<IApiResponse> {
    return this.http.invoke({
      method: apiMethods.get,
      path: `${apiEndPoints.admin}${apiEndPoints.users}`,
      query: queryParams
    });
  }

  public getAnalyticsData(queryParams): Observable<IApiResponse> {
    return this.http.invoke({
      method: apiMethods.get,
      path: `${apiEndPoints.admin}${apiEndPoints.analytics}`,
      query: queryParams
    });
  }
}
